if (!customElements.get('variant-picker')) {
  customElements.define(
    'variant-picker',
    class VariantPicker extends HTMLElement {
      constructor() {
        super();
        this.scentLabel = this.querySelector(".variant-picker__swatch-option__lable__title");
        this.descriptionLabel = this.querySelector(".variant-picker__swatch-option__lable__descritpion");
      }
      connectedCallback() {
        this.waitForSelector();
        const inputs = this.querySelectorAll("input[type='radio']");
        inputs.forEach( input => input.addEventListener('change', (event) => {
          this.variantChange(event)
        }));
        this.querySelectorAll("input[type='radio'][data-redirect-handle]").forEach((input) => {
          input.addEventListener('click', (event) => {
            const url = input.dataset.redirectHandle;
            if (!url) return;
            event.preventDefault();
            window.location.href = url;
          });
        });
        const travelCaseToggleButton = this.querySelector("#tarvel-case__selector");
        travelCaseToggleButton?.addEventListener("change", this.handleCaseSelection.bind(this));
      }
      variantChange(event) {
        const label = event.target.closest(".variant-picker__swatch-option__container").querySelector(".variant-picker__swatch-option__lable__title");
        this.updateLabel(label, event.target.value, event.target.dataset.description);
        const selector = this.querySelector(`#${event.target.dataset.selector}`);
        selector.value = event.target.value;
        selector.dispatchEvent(new Event("change"));
      }
      updateLabel(labelEl, value, description) {
        if (!labelEl) return;
        labelEl.innerHTML = '';

        const nameSpan = document.createElement('span');
        nameSpan.className = 'font-nitti uppercase font-bold';
        nameSpan.textContent = value;
        labelEl.appendChild(nameSpan);

        if (description && description.trim() !== '') {
          const dash = document.createElement('span');
          dash.className = 'mx-1';
          dash.textContent = ' - ';
          const descSpan = document.createElement('span');
          descSpan.textContent = description;
          labelEl.appendChild(dash);
          labelEl.appendChild(descSpan);
        }
      }
      waitForSelector() {
        let $this = this;
        this.mainSelector = this.querySelector(".single-option-selector");
        if (this.mainSelector) {
          this.classList.add("ready");
          return;
        };
        this.observer = new MutationObserver(function(mutationList, observer) {
          for (const mutation of mutationList) {
            if (
              mutation.type === "childList" &&
              Array.from(mutation.addedNodes).some(function(node){
                return node && node.nodeType === 1 && node.classList && node.classList.contains("selector-wrapper");
              })
            ) {
              $this.mainSelector = $this.querySelector(".single-option-selector");
              $this.classList.add("ready");
              $this.observer.disconnect();
            }
          }
        });
        this.observer.observe(this, {childList: true});
      }
      handleCaseSelection(event) {
        const selector_id = event.target.dataset.selector;
        const selector = this.querySelector(`#${selector_id}`);
        const options = selector.options;
        if (event.target.checked) {
          options[1].selected = true;
        } else {
          options[0].selected = true;
        }
        selector.dispatchEvent(new Event("change"));
      }
    }
  );
}
